<template>
  <div v-show="!noRecords">
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
          <ul v-show='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <span>غرض الاتصال:</span>
          <select class="form-control" style="padding: 0px" v-model="record.call_type_id">
            <option v-for="item in callTypes" v-bind:key="item.id" v-bind:value="item.id">
              {{item.name}}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <span>حالة الاتصال:</span>
          <select class="form-control" style="padding: 0px" v-model="record.call_status_id">
            <option v-for="item in callStatus" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <span>الاجراء:</span>
          <select class="form-control" style="padding: 0px" v-model="record.call_action_id">
            <option v-for="item in actions" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <span>التأجيل:</span>
          <select class="form-control" style="padding: 0px" v-model="record.delay">
            <option v-for="item in 30" :value="item -1 " v-bind:key="item" >
              {{ item -1 }}
            </option>
          </select>
        </div>
        <div class='col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
          <span>ملاحظات الاتصال:</span>
          <input  @keyup='mirrorNotes()' class="form-control" v-model="record.callNotes" name='notes' type='text'>
        </div>
        <div class='col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
          <span>ملاحظات الفنى:</span>
          <input  v-model='record.notes' class='form-control' name='notes' type='text'>
        </div>
      </div>
      <div class='col-lg-12' style='padding:0px'>
        <div v-if="isType1" class='col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
          <table width='100%' class='table table-bordered '>
            <thead>
              <tr>
                <th style='padding:2px;text-align: center'>م</th>
                <th style='padding:2px;text-align: center'>التاريخ</th>
                <th style='padding:2px;text-align: center'>المبلغ</th>
                <th style='padding:2px;text-align: center'>المدفوع</th>
                <th style='padding:2px;text-align: center'>الباقى</th>
              </tr>
            </thead>
            <tbody>
              <tr v-on:click="changeAction(record.id)" :class="{highlight :record.action}" class='odd gradeX' v-for='(record) in InstallmentRecords' :key='record.id'>
                <td style='padding:2px;text-align: center'>{{record.id}}</td>
                <td style='padding:2px;text-align: center'>{{record.due_date}}</td>
                <td style='padding:2px;text-align: center'>{{record.amount}}</td>
                <td style='padding:2px;text-align: center'>{{record.total_paid}}</td>
                <td style='padding:2px;text-align: center'>{{record.reset}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="isType1" class='col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
          <table width='100%' class='table table-bordered '>
            <thead>
              <tr>
                <th style='padding:2px;text-align: center'>م</th>
                <th style='padding:2px;text-align: center'>الصنف</th>
                <th style='padding:2px;text-align: center'>التاريخ الافتراضى</th>
                <th style='padding:2px;text-align: center'>تاريخ التغيير</th>
              </tr>
            </thead>
            <tbody>
              <tr v-on:click="changeMaintenanAction(record.id)" :class="{highlight :record.action}" class='odd gradeX' v-for='(record) in maintenancRecords' :key='record.id'>
                <td style='padding:2px;text-align: center'>{{record.id}}</td>
                <td style='padding:2px;text-align: center'>{{record.item}}</td>
                <td style='padding:2px;text-align: center'>{{record.default_date}}</td>
                <td style='padding:2px;text-align: center'>{{record.change_date}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-show='record.call_type_id === 3 || record.call_type_id === 2 || record.call_type_id === 7' class='col-lg-3 col-sm-3' style='padding: 0px 0px 0px 10px;'>
        <label>العرض:</label>
        <input v-show='record.call_type_id === 2 || record.call_type_id === 7' v-model='record.offer_name'  @keypress="isLocked($event)" class='form-control' name='offer' type='text'>
        <select v-show='record.call_type_id === 3' class="form-control" @change='getRest($event)' style="padding: 0px" v-model="record.contract_offer_id">
          <option v-for="item in offers" v-bind:key="item.id" v-bind:value="item.id">
            {{ item.offer_name + ' [' + item.price + ']' }}
          </option>
        </select>
      </div>
      <div v-show='record.call_type_id === 3' class='col-lg-3 col-sm-3' style='padding: 0px 0px 0px 10px;'>
        <tbDate v-show='record.call_type_id === 3' :mytitle='DateTitle' v-model= 'record.date' ></tbDate>
    </div>
      <div class='col-lg-12 col-sm-12' style='padding: 0px 0px 0px 10px;'>
        <div :class="isType1 ? 'col-lg-4 col-sm-4' : 'col-lg-3 col-sm-3'" style='padding: 0px 0px 0px 10px;'>
          <label v-show='record.call_type_id === 1'>تاريخ القسط</label>
          <input  v-show='record.call_type_id === 1' @keypress="isLocked($event)" v-model='receiptDate' class='form-control' name='amount' type='text'>
        </div>
        <div v-show='record.call_type_id < 3' class='col-lg-3 col-sm-3' style='padding: 0px 0px 0px 10px;'>
          <label>الصيانة المطلوبة:</label>
          <input  @keypress="isLocked($event)" v-model='record.maintenance_required' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
          <label>المطلوب:</label>
          {{record.amount_str}}
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
          <label>البيان:</label>
          {{record.caption}}
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
          <label>الباقى:</label>
          {{record.rest_str}}
        </div>
        <div v-show='record.call_type_id === 2 || record.call_type_id === 9' class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>م.صيانة:</label>
          <input   @keypress="isNumber($event)" @keyup='getRest()'  v-model='record.maintenance_expenses' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>الرصيد:</label>
          <input  @keypress="isLocked($event)"  v-model='record.balance' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>المطلوب:</label>
          <input @keypress="isLocked($event)" v-model='record.required' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>المدفوع:</label>
          <input  @keypress="isNumber($event)" @keyup='getRest()' v-model='record.paid' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>الباقى:</label>
          <input  @keypress="isLocked($event)" v-model='record.rest' class='form-control' name='amount' type='text'>
        </div>
      </div>
      <div v-if='!successShow' class='col-lg-12 col-sm-12' style='text-align:center;padding:10px'>
        <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
        <button  @click='saveData()'  style="width: 100px" type='button' class='btn btn-success'>إصدار</button>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #00E40E;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import tafqeet from '@/./assets/Tafqeet.js'
export default {
  components: {
    tbDate
  },
  name: 'CreateDailyReceipts',
  data () {
    return {
      callTypes: [
        {id: 1, name: 'سداد قسط'},
        {id: 7, name: 'سداد قسط عرض'},
        {id: 8, name: 'سداد مديونية صيانة'},
        {id: 2, name: 'تغيير شمع فى عرض'},
        {id: 3, name: 'عرض جديد'},
        {id: 9, name: 'طلب صيانة'}
      ],
      isType1: false,
      actions: {},
      callStatus: {},
      today: true,
      receiptDate: '',
      title: '',
      DateTitle: 'التاريخ',
      defultDateTitle: 'تاريخ القسط',
      dateTitle: 'تاريخ التنفيذ',
      installmentDateTitle: 'تاريخ القسط',
      validationErrors: '',
      records: {},
      record: {},
      offers: {},
      offer_id: 0,
      items: {},
      OfferRecords: {},
      maintenancRecords: {},
      InstallmentRecords: {},
      InstallmentRecord: {},
      types: [{id: 0, name: 'غير نشط'}, {id: 1, name: 'نشط'}],
      btnTitle: 'عرض الكل',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      Localcontract_id: 0,
      isContractOffersLoading: false,
      isOfferRecordsLoading: false,
      branches: {},
      type: 0,
      contract_offer_id: 0,
      uid: '',
      dateFrom: '',
      dateTo: '',
      noRecords: false,
      isInLimit: false
    }
  },
  props: {
    callMethod: ''
  },
  methods: {
    tabSelected (id, fromDate, toDate, type, offerID, isInLimit, offers) {
      this.offers = offers
      this.InstallmentRecords = null
      this.maintenancRecords = null
      this.record = null
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      this.validationErrors = ''
      this.GetCallData()
      this.dateFrom = fromDate
      this.dateTo = toDate
      this.uid = id
      this.offer_id = offerID
      this.contract_offer_id = offerID
      this.isInLimit = isInLimit
      // -----------------------------------------------------
      this.record = {}
      this.type = type
      this.getData(id, fromDate, toDate, type)
      this.OfferRecords = ''
    },
    // ========================================================
    GetCallData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-customer-call-logs', {
        token: localStorage.getItem('token'),
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.isLoadingData = false
          this.actions = res.data.Actions
          this.callStatus = res.data.Status
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ========================================================
    addDays () {
      /*
      var date = new Date(this.record.default_date)
      date.setTime(date.getTime() + (this.record.call_delay * 24 * 60 * 60 * 1000))
      var dd = date.getDate()
      var mm = date.getMonth() + 1
      var y = date.getFullYear()
      var newDate = y + '-' + mm + '-' + dd
      this.date = newDate
      */
    },
    // ========================================================
    getRest () {
      if (this.record.type_id === 3) {
        let i = this.offers.findIndex(x => x.id === parseInt(this.record.contract_offer_id))
        this.record.required = parseInt(this.offers[i].price || 0)
        this.record.caption = this.offers[i].label
        this.record.rest = parseInt(this.record.required || 0) - parseInt(this.record.paid || 0)
        if (this.record.paid > 0) {
          this.record.amount_str = '-مبلغ وقدره ' + this.record.paid + ' جنيه ' + tafqeet(this.record.paid) + ' جنيهاً فقط لا غير-'
        } else {
          this.record.amount_str = 'لا شيئ'
        }
        if (this.record.rest > 0) {
          this.record.rest_str = 'والمبلغ المتبقى ' + this.record.rest + 'ج فقط ' + tafqeet(this.record.rest) + ' جنيهاً لا غير'
        } else {
          this.record.rest_str = 'المبلغ المتبقى: صفر (لا توجد اقساط مستحقة من ثمن العرض)'
        }
      } else {
        this.record.required = parseInt(this.record.maintenance_expenses || 0) + parseInt(this.record.balance || 0)
        this.record.rest = parseInt(this.record.required || 0) - parseInt(this.record.paid || 0)
        // -----------------------------
        if (this.record.paid > 0) {
          this.record.amount_str = '-مبلغ وقدره ' + this.record.paid + ' جنيه ' + tafqeet(this.record.paid) + ' جنيهاً فقط لا غير-'
        } else {
          this.record.amount_str = ''
        }
        // -----------------------------
        if (this.record.type_id === 7) {
          this.record.caption = this.record.item + ' المستحقة لدى الشركة '
        } else if (this.record.type_id === 8) {
          if (this.record.rest === 0) {
            this.record.caption = 'وذلك قيمة سداد الصيانة المستحقة لدى الشركة'
          } else {
            this.record.caption = 'وذلك قيمة سداد جزء من قيمة الصيانة المستحقة لدى الشركة: '
          }
        } else if (this.record.type_id === 2) {
          var label = ''
          var maintenanceExpenses = ''
          if (this.record.label !== null) {
            label = this.record.label
          }
          if (parseInt(this.record.maintenance_expenses) > 0) {
            if (this.record.label === null) {
              maintenanceExpenses = ' م.صيانة بقيمة ' + this.record.maintenance_expenses + 'ج '
            } else {
              maintenanceExpenses = ' + م.صيانة بقيمة  ' + this.record.maintenance_expenses + 'ج '
            }
          }
          this.record.caption = label + maintenanceExpenses
        }
        // --------------------------------------
        if (this.record.rest > 0) {
          this.record.rest_str = 'والمبلغ المتبقى ' + this.record.rest + 'ج فقط ' + tafqeet(this.record.rest) + ' جنيهاً لا غير'
        } else {
          this.record.rest_str = 'المبلغ المتبقى: صفر (لا توجد اقساط مستحقة من ثمن الفلتر)'
        }
      }
    },
    // ========================================================
    changeMaintenanAction (id) {
      let i = this.maintenancRecords.map(record => record.id).indexOf(id)
      if (i > -1) {
        if (this.maintenancRecords[i].change_date === null) {
          this.maintenancRecords[i].action = !this.maintenancRecords[i].action
        }
      }
      let instID = null
      this.maintenancRecords.forEach(function (rec) {
        if (rec.action) {
          if (instID !== null) {
            instID = instID.concat(' + ', rec.caption)
          } else {
            instID = rec.caption
          }
        }
      })
      if (instID !== null) {
        this.record.maintenance_required = instID
      } else {
        this.record.maintenance_required = ''
      }
    },
    // ========================================================
    changeAction (id) {
      let i = this.InstallmentRecords.map(record => record.id).indexOf(id)
      if (i > -1) {
        if (this.InstallmentRecords[i].reset > 0) {
          this.InstallmentRecords[i].action = !this.InstallmentRecords[i].action
        }
      }
      let instID = null
      let instMonth = null
      let MyDate = null
      this.InstallmentRecords.forEach(function (rec) {
        if (rec.action) {
          MyDate = rec.due_date
          if (instID !== null) {
            instID = instID.concat(' + ', rec.id)
            instMonth = instMonth.concat(' + ', rec.due_date.substring(5, 7))
          } else {
            instID = rec.id.toString()
            instMonth = rec.due_date.substring(5, 7)
          }
        }
      })
      // ------------------------------
      const d = new Date()
      let month = d.getMonth() + 1
      let year = d.getFullYear()
      let Myday = MyDate.substring(10, 8)
      this.receiptDate = year + '-' + month + '-' + Myday
      // ------------------------------
      if (instID !== null) {
        this.record.caption = 'وذلك قسط رقم )' + instID + '(' + ' عن شهر: ' + instMonth
      } else {
        this.record.caption = ''
      }
    },
    // ========================================================
    mirrorNotes () {
      this.record.notes = this.record.callNotes
    },
    // ========================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    getMaintenanceRequestData (id) {
      this.isContractOffersLoading = true
      axios.post(this.$apiURL + 'get-maintenance-request-customer-data', {
        token: localStorage.getItem('token'),
        uid: id
      })
        .then(res => {
          this.isContractOffersLoading = false
          this.record = res.data
          this.OfferRecords = ''
          this.maintenancRecords = ''
          this.record.call_type_id = 1
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isContractOffersLoading = false
        })
    },
    getData (id, fromDate, toDate, type) {
      this.isContractOffersLoading = true
      this.noRecords = false
      axios.post(this.$apiURL + 'get-rec-for-create-receipt', {
        token: localStorage.getItem('token'),
        id: id,
        type: type,
        offer_id: this.offer_id,
        branch_id: this.$store.state.customerData.branche_id,
        contract_offer_id: this.contract_offer_id,
        date_from: fromDate,
        isInLimit: this.isInLimit,
        date_to: toDate
      })
        .then(res => {
          if (res.data === 'No Records') {
            this.noRecords = true
          } else {
            this.isContractOffersLoading = false
            if (parseInt(type) === 1) {
              this.isType1 = true
              this.record = res.data.Data
              this.record.delay = 0
              this.InstallmentRecords = res.data.Installment
              this.maintenancRecords = res.data.Maintenances
              this.changeAction(0)
            } else {
              this.isType1 = false
              this.record = res.data
            }
            this.getRest()
            if (parseInt(type) === 2) {
              this.record = res.data.Data[0]
              this.OfferRecords = res.data.OfferRecords
              this.maintenancRecords = res.data.Maintenance
              var caption = ''
              for (let i = 0; i < res.data.Data.length; i++) {
                caption = (res.data.Data[i].maintenance_required) + ' ' + caption
              }
              this.record.offer = res.data.Data[0].offer_name
              res.data.Data[0].maintenance_required = caption
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isContractOffersLoading = false
        })
    },
    getInstallmentData (id, fromDate, toDate) {
      this.isContractOffersLoading = true
      axios.post(this.$apiURL + 'get-installment-collecting-customer-data', {
        token: localStorage.getItem('token'),
        uid: id,
        date_from: fromDate,
        date_to: toDate
      })
        .then(res => {
          this.isContractOffersLoading = false
          this.record = res.data.Data[0]
          this.OfferRecords = res.data.OfferRecords
          this.maintenancRecords = res.data.Maintenance
          var caption = ''
          for (let i = 0; i < res.data.Data.length; i++) {
            caption = (res.data.Data[i].caption) + ' ' + caption
          }
          res.data.Data[0].caption = caption
          this.getRest()
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isContractOffersLoading = false
        })
    },
    saveData () {
      this.validationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'create-maintenance-cash-receipt', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        contract_id: this.record.contract_id,
        contract_offer_id: this.record.contract_offer_id,
        amount: this.record.paid,
        amount_str: this.record.amount_str,
        maintenance_expenses: this.record.maintenance_expenses,
        caption: this.record.caption,
        date: this.receiptDate,
        delay: this.record.delay,
        rest: this.record.rest,
        rest_str: this.record.rest_str,
        type_id: this.type,
        maintenance_required: this.record.maintenance_required,
        notes: this.record.notes,
        call_status_id: this.record.call_status_id,
        call_action_id: this.record.call_action_id,
        call_type_id: this.record.call_type_id,
        callNotes: this.record.callNotes,
        call_delay: this.record.call_delay,
        date_from: this.dateFrom,
        date_to: this.dateTo
      })
        .then(res => {
          this.callMethod(this.offer_id)
          this.isLoadingSave = false
          this.OfferRecords = res.data.OfferRecords
          this.record.id = res.data.RecId
          this.errorShow = false
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CreateDailyReceipts.vue